module.exports = __webpack_public_path__ + "01f43047/img/product-icon-grey.b248963c.svg";